module.exports = __webpack_public_path__ + "static/media/ajax-Loader.434d5a60.gif";